var map = {
	"./config.localhost": 151,
	"./config.localhost.js": 151,
	"./config.prod": 6816,
	"./config.prod.js": 6816,
	"./config.testing": 6075,
	"./config.testing.js": 6075,
	"./config.uat": 3120,
	"./config.uat.js": 3120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6661;